import { resetMapLoadedEv, setMapLoadedEv } from './events.js';
import { $mapLoaded } from './stores.js';

$mapLoaded.on(setMapLoadedEv, (_, payload) => payload).reset(resetMapLoadedEv);
